import { MenuItem, Stack, TextField, Typography } from "@mui/material"
import { useState, useEffect } from "react"
import API from "../../services/API"
import moment from "moment/moment";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useContext} from "react"
import UserContext from "../../services/Context/UserContext"

export default function Chart({courses}){

    const {user} = useContext(UserContext)

    const [data, setData] = useState(null)

    const [chart, setChart] = useState({
        width: 0,
        height: 0,
        range: 12
    })

    const [colors, setColors] = useState([]);

    useEffect(() => {

        /** User color first */
        const userColor = (user.category?.color || defaultColors[0]).toLowerCase();

        let newColors = [userColor];
        
        defaultColors.forEach(c => {
            if(c !== userColor) newColors.push(c); 
        })

        setColors(newColors)

        API.get('/teachers/me/history')
            .then(r => setData(r.data))

    }, [user])


    const rows = () => {

        let rows = [];

        for(let i = 0; i <= chart.range; i++){

            let m = moment().add(i * -1, 'month');

            let firstDay = m.format('YYYY-MM-01');

            let row = {
                Mois: moment(firstDay).format('MMM Y'),
            };

            let items = (Array.isArray(data) ? data : []).filter(i => i.date === firstDay);

            row['Encaissé'] = items.map(i => i.cashed).reduce((a,b) => a + b, 0);

            row['Total'] = items.map(i => i.enrollments).reduce((a,b) => a + b, 0);

            courses.forEach(c => {

                let item = items.find(i => i.id === c.id);

                row[c.title] = item?.enrollments || 0;
            })

            rows.push(row);
        }

        return rows.reverse();
    }

    const sum = key => rows().map(r => r[key]).reduce((a,b) => a + b, 0)


    const resize = () => {
        const stack = document.getElementById('teacher-chart');

        if(!stack || !stack.offsetWidth) return false;

        const w = stack.offsetWidth;
        const h = w < 600 ? w : Math.round(w / 3);

        setChart({...chart, width: w, height: h})
    }

    if(!chart.width){

        window.addEventListener('resize', () => resize(), true);

        resize();
    }
  

    return <Stack id='teacher-chart' spacing={4}>

            <Stack direction="row" justifyContent="space-between" alignItems="center" flexWrap="wrap">

                <TextField
                    select
                    label="Inscriptions par période"
                    value={chart.range}
                    onChange={e => setChart({...chart, range: parseInt(e.target.value)})}
                    size='small'
                    sx={{width: 300}}
                    variant='standard'
                >
                    <MenuItem value={6}>6 derniers mois</MenuItem>
                    <MenuItem value={12}>Dernière année</MenuItem>
                    <MenuItem value={18}>18 derniers mois</MenuItem>
                    <MenuItem value={24}>2 dernières années</MenuItem>
                    <MenuItem value={36}>3 dernières années</MenuItem>
                </TextField>

                <Typography variant="body2" color="text.secondary">
                    {sum('Total').toLocaleString()} inscriptions sur la période dont {sum('Encaissé').toLocaleString()} encaissées
                </Typography>

            </Stack>

            <Stack sx={{alignSelf: 'center'}}>

                <LineChart
                    width={chart.width}
                    height={chart.height}
                    data={rows()}
                >

                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis dataKey="Mois" />
                    
                    <YAxis />

                    <Tooltip />

                    <Legend />

                    {courses.map((c,n) => 
                        <Line 
                            key={c.id} 
                            type="monotone" 
                            dataKey={c.title} 
                            stroke={colors[n] || colors[0]}
                            strokeWidth={2}
                        />
                    )}

                    <Line 
                        type="monotone" 
                        dataKey="Encaissé" 
                        stroke="rgb(150,150,150)"
                        strokeWidth={2}
                    />

                </LineChart>

            </Stack>

    </Stack>
}


const defaultColors = ['#43b1e6','#038b99','#f7794f','#0aa67e','#f5c266','#ea4c74'];